import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
import { RouterModule, Routes} from '@angular/router';
// import { HeroesComponent } from './heroes/heroes.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AdminAuthorizedGuard } from './admin-authorized.guard';
import {AsyncObservableComponent} from './async-observable/async-observable.component';
import {ProfileComponent} from './profile/profile.component';


/*@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})*/
const routes: Routes = [
  // { path: 'heroes', component: HeroesComponent }
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'login', component: LoginComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'async', component: AsyncObservableComponent },
  { path: 'home', component: HomeComponent }, // , canActivate: [AdminAuthorizedGuard]
  { path: 'profile', component: ProfileComponent },
  { path: '**', component: PageNotFoundComponent }  // Wildcard route for a 404 page //https://angular.io/guide/router#displaying-a-404-page
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
